export const getAnalyticsPrice = (price: number | undefined) => {
    if (!price) {
        return 'null';
    }
    return price.toFixed(2);
};
